export function naturalSort(a: string, b: string): number {
  const regex = /\d+|\D+/g;

  // Convert to lowercase for case-insensitive sorting
  const aLower = a.toLowerCase();
  const bLower = b.toLowerCase();

  const aParts = aLower.match(regex) || [];
  const bParts = bLower.match(regex) || [];

  for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
    const aPart = aParts[i];
    const bPart = bParts[i];

    const aNum = parseInt(aPart, 10);
    const bNum = parseInt(bPart, 10);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      if (aNum !== bNum) return aNum - bNum;
    } else {
      const cmp = aPart.localeCompare(bPart);
      if (cmp !== 0) return cmp;
    }
  }

  return aParts.length - bParts.length;
}

export function nonEmptyArray<T>(arr: T[]): [T, ...T[]] {
  if (arr.length < 1) {
    throw new Error("Instantiated with fewer than one item");
  }

  return arr as [T, ...T[]];
}
